import React from "react";
import { Select } from "antd";
import { useQuery } from "react-query";

import { LookUpApiService } from "../../../ApiServices";
import notificationService from "../../../util/notification.service";
import { API_STORAGE_KEY } from "../../../constants/constant";

const getNeighborhoods = async () => {
    const { ok, data, response } = await LookUpApiService.getZipCodes();
    if (ok) {
        return data;
    } else {
        notificationService.error(response.message);
        throw new Error(response.message);
    }
};

const NeighborhoodLookup = (props) => {
    const { isCustomizeWidth = true } = props;

    const { data: neighborhoods = [], isLoading } = useQuery(API_STORAGE_KEY.VIEW_ZIPCODES, getNeighborhoods);

    return (
        <Select
            {...props}
            showSearch
            filterOption={(input, option) => {
                const label = option?.children?.toString()?.toLowerCase() || "";
                const zipCode = option?.value?.toString()?.toLowerCase() || "";
                return (
                    label.includes(input.toLowerCase()) || zipCode.includes(input.toLowerCase())
                );
            }}
            style={{
                ...(isCustomizeWidth && {
                    width: "150px",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis"
                })
            }}
            allowClear
            loading={isLoading}
            disabled={isLoading}
            getPopupContainer={(triggerNode) => triggerNode.parentElement}
        >
            {neighborhoods?.map((data) => {
                return (
                    <Select.Option key={data?.id} value={data.zipCode}>
                        {data?.name} {data?.zipCode}
                    </Select.Option>
                );
            })}
        </Select>
    );
};

export default NeighborhoodLookup;
